import { present } from 'shared/presenters/presenter'
import { Notifications } from 'shared/presenters/graphqlTypes'
import dayjs from 'dayjs'
import * as relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime.default)

const icons = {
  new_booking: 'booking',
  cancelled_booking: 'cancel',
  assign_instructor: 'user',
  ads_expired: 'expired',
  eola_msg: 'message-new',
  shaka_msg: 'shaka',
  instructor_joined: 'user-new',
  voucher_purchased: 'voucher',
  request_to_cancel: 'cancel',
  arbitrary_purchase: 'purchase',
  new_subscription: 'subscription-new',
  qualification_expiring: 'qualification',
  basket_purchased: 'basket',
  invoice_paid: 'invoice',
  invoice_payment_failed: 'invoice'
}

/** This is needed because `kind` is stored as a numeric value in the database */
const iconsAsArray = Object.values(icons)

export class NotificationPresenter extends present<Notifications>() {
  iconName = () => {
    if (typeof this.kind === 'undefined') {
      return ''
    }

    return iconsAsArray[this.kind]
  }
  createdAtTimeFromNow = () => {
    return dayjs(this.created_at).fromNow()
  }
}
